import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {deleteNote} from '../actions/ClientActions';
import Modal from '../components/Modal';

@connect(
    state => ({
        isSaving: state.modal.isDeletingNote,
    }),
    dispatch => bindActionCreators({deleteNote}, dispatch)
)
export default class ConfirmDeleteNoteModal extends Component {
    handleDelete() {
        this.props.deleteNote(this.props.noteId);
    }
    render() {
        var actionButton = this.props.isSaving ?
            (<button className="btn btn-danger disabled">Deleting...</button>) :
            (<button className="btn btn-danger" onClick={this.handleDelete.bind(this)}>Delete</button>);

        return (
            <Modal actionButton={actionButton} className="modal-danger" title={"Delete note"}>
                <p>Are you sure</p>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/ConfirmDeleteNoteModal.js